// @flow
import * as React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import styled from "styled-components"
import { connect } from "react-redux"
import { TweenMax, Cubic } from "gsap"
import { setModal } from "../../Modal"
import type { Match, RouterHistory } from "react-router-dom"
import type { SetModal } from "../../Modal"
import type { IntlShape } from "react-intl"

import {
  Container,
  Modal,
  Content,
  GlossaryBody,
  Header,
  PrimaryHeading,
  PrimaryButton,
  ButtonGroup,
  Fade
} from "../Modal"

const SurveyFrame = styled.iframe`
  height: 640px;
  margin: auto;
  width: 800px;
  display: block;
  border: none;
  border-radius: 2rem;
  margin-bottom: 2rem;
`

type Props = {
  match: Match,
  history: RouterHistory,
  setModal: SetModal,
  intl: IntlShape
}

type State = {
  showSurvey: boolean
}

class SurveyModal extends React.Component<Props, State> {
  body: ?HTMLElement
  fade: ?HTMLElement

  constructor(props) {
    super(props)
    this.body = null
    this.fade = null
    this.state = { showSurvey: false }
  }

  componentDidMount = () => {
    this.setState({ showSurvey: true })
    TweenMax.set(this.body, { y: "-=50", opacity: 0 })
    TweenMax.set(this.fade, { opacity: 0 })
    TweenMax.to(this.body, 0.5, { ease: Cubic.easeOut, opacity: 1, y: 0 })
    TweenMax.to(this.fade, 0.5, { ease: Cubic.easeOut, opacity: 1 })
  }

  handleClose = () => {
    this.dismiss()
  }

  dismiss = () => {
    const { history, setModal } = this.props

    this.setState({ showSurvey: false })
    setTimeout(() => {
      setModal(false)
      TweenMax.to(this.body, 0.5, {
        ease: Cubic.easeOut,
        opacity: 0,
        y: "+=50"
      })
      TweenMax.to(this.fade, 0.5, {
        ease: Cubic.easeOut,
        opacity: 0,
        onComplete: () => {
          history.goBack()
        }
      })
    }, 500)
  }

  render() {
    const { intl: { formatMessage } } = this.props
    return (
      <Container>
        <Fade
          onClick={() => this.handleClose()}
          dark
          innerRef={el => (this.fade = el)}
        />
        <Modal>
          <GlossaryBody innerRef={el => (this.body = el)}>
            <Header>
              <PrimaryHeading>
                <FormattedMessage id="kiosk.survey.title" />
              </PrimaryHeading>
            </Header>
            <Content>
              {this.state.showSurvey ? (
                <SurveyFrame src={formatMessage({ id: "kiosk.survey.url" })} />
              ) : (
                <span />
              )}
              <ButtonGroup>
                <PrimaryButton onClick={this.handleClose}>
                  <FormattedMessage id="kiosk.survey.close" />
                </PrimaryButton>
              </ButtonGroup>
            </Content>
          </GlossaryBody>
        </Modal>
      </Container>
    )
  }
}

export default connect(null, {
  setModal
})(injectIntl(SurveyModal))



// WEBPACK FOOTER //
// ./src/Kiosk/SurveyModal/SurveyModal.js